import React, { useContext, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

import { YEAR_DASH_MONTH_DASH_DAY } from '../../../../../../constants/dateFormat';
import { getPatientFullName, getPatientPreferredName } from '../../../../../../services/patient';
import { PageInfoHeader } from '../../../../../PageInfoHeader/PageInfoHeader';
import { generateUrlByKey, useCurrentRoute } from '../../../../../root/router';
import { dateFormatForShow } from '../../../Patients/PatientStatusChange/PatientStatusChangeConstants';
import { ReviewContext } from '../ReviewContext';
import { isSmOrPiReview } from '../reviewService';

export default function ReviewInfoHeader() {
  const { reviewType, reviewMetaData, ssuPatientId, patientEncounterId } = useContext(ReviewContext);

  const { params, parent } = useCurrentRoute();
  const { patientId } = params;
  const patientInfoKey = parent?.parent?.key;

  const dateOfBirth = reviewMetaData?.dob ? getFormattedDOB(reviewMetaData.dob) : '---';
  const studyName = reviewMetaData?.studyName;
  const siteName = reviewMetaData?.siteName;

  const urlForPatientInfoPage = useMemo(
    function() {
      if (!patientInfoKey) {
        return null;
      }
      return generateUrlByKey(patientInfoKey, {
        ssuPatientId,
        patientEncounterId,
        patientId
      });
    },
    [patientInfoKey, ssuPatientId, patientId, patientEncounterId]
  );

  return (
    <PageInfoHeader
      objectRecordLabel={true}
      withLabel={false}
      pageInfo={
        <PageInfoHeader.CollapsibleList>
          {isSmOrPiReview(reviewType) && (
            <PageInfoHeader.AdditionalInfo tooltip="Patient Name">
              <NavLink to={urlForPatientInfoPage}>
                {getPatientFullName(reviewMetaData) + getPatientPreferredName(reviewMetaData)}
              </NavLink>
            </PageInfoHeader.AdditionalInfo>
          )}
          {isSmOrPiReview(reviewType) && (
            <PageInfoHeader.AdditionalInfo title="Patient ID">
              {reviewMetaData?.patientID}
            </PageInfoHeader.AdditionalInfo>
          )}
          <PageInfoHeader.AdditionalInfo title="Subject ID">
            {reviewMetaData?.subjectId || 'No Subject ID'}
          </PageInfoHeader.AdditionalInfo>
          <PageInfoHeader.AdditionalInfo tooltip="Date of Birth ">{dateOfBirth}</PageInfoHeader.AdditionalInfo>
          <PageInfoHeader.AdditionalInfo tooltip="Study">{studyName}</PageInfoHeader.AdditionalInfo>
          <PageInfoHeader.AdditionalInfo tooltip="Site">{siteName}</PageInfoHeader.AdditionalInfo>
        </PageInfoHeader.CollapsibleList>
      }
    />
  );
}

function getFormattedDOB(dob) {
  const age = moment().diff(moment(dob, YEAR_DASH_MONTH_DASH_DAY), 'years');
  return `${moment(dob).format(dateFormatForShow)} (${age} ${age === 1 ? 'year' : 'years'})`;
}
